import React, {Component, ReactElement} from 'react'
import {ConditionTableFixed} from '../../../../styledComponents/adminPage/ConditionTable';
import {StyledTableCaption, TableRowName} from '../../../../styledComponents/adminPage/Table';
import {FACILITY_RESERVATION_CLASSIFICATION} from '../../../../CodeMaster';
import { TableRow, TableCell, TableBody } from '@mui/material';

interface Props {
    facilityReserveCategory: string
    userRidgeName: string
    userRoomNumber: string
    userFamilyName: string
    userFirstName: string
    adminFamilyName: string
    adminFirstName: string
    userRoleName: string
    stayAvailability: boolean
}

class NatAdminFacilityReserveUserInfoViewComponent extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render(): ReactElement {
        const {
            stayAvailability, userRidgeName, userRoomNumber,
            facilityReserveCategory, userFamilyName, userFirstName,
            adminFamilyName, adminFirstName, userRoleName,
        } = this.props;

        return (
            <ConditionTableFixed>
                <colgroup>
                    <col width={'15%'}/>
                    <col width={'15%'}/>
                    <col width={'10%'}/>
                    <col width={'15%'}/>
                    <col width={'10%'}/>
                    <col width={'10%'}/>
                </colgroup>
                <StyledTableCaption>利用者情報</StyledTableCaption>
                <TableBody>
                    {facilityReserveCategory !==
                    FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                    <>
                        <TableRow>
                            <TableRowName>部屋番号</TableRowName>
                            <TableCell colSpan={5}>
                                {userRidgeName} {userRoomNumber}
                            </TableCell>
                        </TableRow>
                    </>
                    }
                    <TableRow>
                        <TableRowName>氏名</TableRowName>
                        <TableCell colSpan={(facilityReserveCategory !==
                            FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) ? 2 : 5}>
                            {userFamilyName} {userFirstName}
                        </TableCell>
                        {facilityReserveCategory !==
                        FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                        <>
                            <TableRowName>管理者確認用氏名</TableRowName>
                            <TableCell colSpan={2}>
                                {adminFamilyName} {adminFirstName}
                            </TableCell>
                        </>
                        }
                    </TableRow>
                    <TableRow>
                        <TableRowName>権限</TableRowName>
                        <TableCell colSpan={5}>
                            {userRoleName}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </ConditionTableFixed>
        )
    }
}

export default NatAdminFacilityReserveUserInfoViewComponent;
